import { Link } from "react-router-dom";
import { useTheme } from "@mui/styles";
import { useTranslation } from "react-i18next";
import React from "react";

import { SHOPIFY_URL } from "../../utils/shopify.utils";
import ContainedButton from "../../components/Buttons/ContainedButton";

const ReturnsSlice4 = () => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <div className="col-3" style={{ maxWidth: 850 }}>
      <div
        style={{
          width: "100%",
          color: theme.COLORS.BLUE.darkBlueGreen,
          fontSize: "2rem",
          marginTop: "5vh",
        }}
      >
        {t("The 20 Year evr-guarantee")}
      </div>
      <div
        style={{
          width: "68%",
          color: theme.COLORS.BLUE.darkBlueGreen,
          fontSize: "1.1rem",
          fontWeight: "bold",
          marginTop: "1vh",
        }}
      >
        {t("We meant it when we said never buy another bed.")}
      </div>
      <div
        style={{
          width: "70%",
          color: theme.COLORS.BLUE.darkBlueGreen,
          fontSize: "1.1rem",
          marginTop: "2vh",
        }}
      >
        {t(
          "Not only can our components be updated overtime from your own natural wear and tear but we also guarantee the consturction of key components. Our mattresses were built to be upgraded over time."
        )}
      </div>
      <div
        style={{
          width: "72%",
          color: theme.COLORS.BLUE.darkBlueGreen,
          fontSize: "1.1rem",
          marginTop: "2vh",
        }}
      >
        {t("Components that can be upgraded overtime include")}
      </div>
      <ul
        style={{
          color: theme.COLORS.BLUE.darkBlueGreen,
          fontSize: "1.1rem",
          marginTop: "2vh",
        }}
      >
        <li>Comfort Layer</li>
        <li>Support Layer</li>
        <li>Zip Off Quilted Cover</li>
      </ul>
      <div
        style={{
          width: "72%",
          color: theme.COLORS.BLUE.darkBlueGreen,
          fontSize: "1.1rem",
          marginTop: "3vh",
        }}
      >
        {t(
          "The 20 Year evr-guarantee applies to the core of you evrbed, the spring units. Springs Units and individual coils are 100% covered or repaired for the 20 year duration. Core units will generally last longer, but we want you to know you are covered for at least 20."
        )}
      </div>
      <div className="row" style={{ marginTop: "5vh" }}>
        <Link
          to={"/warranty"}
          style={{
            color: theme.COLORS.WHITE.backgroundWhite,
            textDecoration: "none",
            width: "auto",
          }}
        >
          <ContainedButton
            className="col-auto"
            styles={{ width: "15vw" }}
            onClick={() => {
              return (window.top.location.href = SHOPIFY_URL + "pages/warranty");
            }}
          >
            {t("FULL WARRANTY DETAILS")}
          </ContainedButton>
        </Link>
        <ContainedButton
          className="col-auto"
          color={theme.COLORS.BLUE.backgroundBlue}
          fontColor={theme.COLORS.BLUE.darkBlueGreen}
          variant="outlined"
          onClick={() => {
            return (window.top.location.href = SHOPIFY_URL + "collections/all");
          }}
        >
          {t("SHOP COMPONENTS")}
        </ContainedButton>
      </div>
    </div>
  );
};

export default ReturnsSlice4;
